export interface Checklist {
    id?: string;
    title?: string;
    priority?: number;
    tasks?: Task[];
}

export interface Task {
    title?: string;
    description?: string;
    /** A preset name (purple|blue|green|yellow|red|gray) OR a custom hex colour (#rrggbb). */
    label?: string;
    /** Rich task detail (Slack/Trello-style). */
    subItems?: ChecklistSubItem[];
    notes?: string;
    links?: TaskLink[];
    attachments?: TaskAttachment[];
    /**
     * OE-148: paused = dormant — the backend engine generates nothing for this
     * item and its dates stop driving the board's performAt. Absent = active.
     */
    paused?: boolean;
}

export interface ChecklistSubItem {
    id: string;
    text: string;
    done: boolean;
}

export interface TaskLink {
    url: string;
    label?: string;
}

export interface TaskAttachment {
    name: string;
    url: string;
    /** Storage path — kept so the file can be deleted from Storage later. */
    path: string;
    /** MIME type, e.g. image/png, application/pdf. */
    type?: string;
    /** Size in bytes. */
    size?: number;
}

export interface YearlyDateField {
    index: number;
    value: any;
    value2: any;
    value3: any;
    value4: any;
    name: string;
    name2: string;
    name3: string;
    name4: string;
    alerts?: Array<AlertFormField>;
}

export interface AlertFormField {
    dateName: string;
    timeName: string;
    dateValue: any;
    timeValue: Date;
    index: number;
    daysBeforeName?: string;
    daysBeforeValue?: any;
    weekDayName?: string;
    weekDayValue?: any;
}

export interface TimeValue {
    hour: number;
    minute: number;
}

export interface EmbeddedTimeValue {
    alertTime: TimeValue;
}
